function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityParkingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.334 16.131c1.36 0 2.42-1.12 2.42-2.56 0-1.42-1.04-2.5-2.42-2.5h-2.5v5.06h2.5zm.2-7.86c3.08 0 5.422 2.3 5.422 5.32 0 3.02-2.341 5.341-5.422 5.341h-2.7v5.081h-3.001V8.27h5.7zM5.936 5c-.552 0-1 .449-1 1v19.94a1 1 0 001 1h19.941a1 1 0 001-1V6c0-.551-.448-1-1-1H5.937zm19.941 23.94H5.937c-1.655 0-3-1.344-3-3V6c0-1.654 1.345-3 3-3h19.94c1.655 0 3 1.346 3 3v19.94c0 1.656-1.345 3-3 3z",
    fill: props.color
  }));
}

export default SvgIconFacilityParkingFilled;